import { Button, Form, FormInstance, Input, message, Select } from 'antd'
import React, { Component, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import {
    stepperMoving, getDataInfo, savePartnerID, addCompanies,
    getOnePartner, getRequestID, getUserAccounts, viewAccountTable
} from '../stores/actions';
import { getApi } from '../apis';
// import regex from '../utils/helper'
import { OutPutResult, Spinner, UserAccounts } from '@operations/shared';
import { withRouter, RouteComponentProps } from "react-router-dom";
import { deployedCompanies, getCompaniesGroups, getPartners, unDeployedCompanies, companiesApi, getOnePartnerApi } from '../utils/apisConsts';
import { errorMessage } from '../utils/commonStringsConsts'
import GetInfoPic from '../assets/images/getInfoPic.png'
import { getRegion } from './regionWrapper';
import { Region } from '../utils/commonInterfaces';

const { Option } = Select;

const PhoneIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="7" y="2.5" width="10" height="19" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M11 18.5h2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

const IdIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="9" cy="12" r="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M14 10.5h4M14 13.5h3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

const ChevronIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

type IdentityFieldsProps = {
    value?: string;
    onChange?: (value: string) => void;
    primaryLabel: string;
    primaryPlaceholder: string;
    showAlternate: boolean;
    alternateIsId: boolean;
    onMode: (isUserID: boolean) => void;
};

function IdentityFields({
    value,
    onChange,
    primaryLabel,
    primaryPlaceholder,
    showAlternate,
    alternateIsId,
    onMode,
}: IdentityFieldsProps) {
    const [active, setActive] = useState<'primary' | 'alternate'>(alternateIsId ? 'alternate' : 'primary');

    useEffect(() => {
        if (alternateIsId) setActive('alternate');
    }, [alternateIsId]);

    const emit = (isUserID: boolean, next: string) => {
        setActive(isUserID ? 'alternate' : 'primary');
        onMode(isUserID);
        onChange?.(next);
    };

    const current = value || '';
    const filled = current.length > 0;
    const placeholder = primaryPlaceholder.replace(/^Enter\s+(the\s+)?/i, '');

    const field = (
        fieldKey: 'primary' | 'alternate',
        label: string,
        fieldPlaceholder: string,
        icon: React.ReactNode,
    ) => {
        const isActive = active === fieldKey;
        const className = [
            'lookup__field',
            filled && isActive ? 'is-active' : '',
            filled && !isActive ? 'is-idle' : '',
        ].filter(Boolean).join(' ');

        return (
            <label className={className}>
                <span className="lookup__field-label">{label}</span>
                <span className="lookup__control">
                    <span className="lookup__glyph">{icon}</span>
                    <Input
                        bordered={false}
                        allowClear
                        autoComplete="off"
                        spellCheck={false}
                        value={isActive ? current : ''}
                        placeholder={fieldPlaceholder}
                        onChange={(event) => emit(fieldKey === 'alternate', event.target.value)}
                    />
                </span>
            </label>
        );
    };

    return (
        <div className="lookup__choices">
            {field('primary', primaryLabel, placeholder, /phone/i.test(primaryLabel) ? <PhoneIcon /> : <IdIcon />)}
            {showAlternate && (
                <>
                    <div className="lookup__or" aria-hidden="true"><span>or</span></div>
                    {field('alternate', 'User ID', 'User ID', <IdIcon />)}
                </>
            )}
        </div>
    );
}


interface Props extends RouteComponentProps<any> {
    stepperMoving(num: number): void
    stepNumber: number,
    getDataInfo(info: {}): void,
    getApi?: any,
    apiLink?: string,
    isNonDeployedCompanies?: boolean,
    isDeployedCompanies?: boolean,
    request?: boolean,
    isPartner?: boolean,
    savePartnerID(value: number | string): void,
    isHoldingComp?: boolean,
    placeHolder?: string,
    isAllCompanies?: boolean,
    isMultipleSelect?: boolean,
    addCompanies(value: []): void,
    getRequestID(value: []): void,
    isApprovedUser?: boolean,
    unSuspendUser?: boolean,
    suspendUser?: boolean,
    userStatus?: boolean,
    param?: boolean,
    isAdjustment?: boolean,
    onePartner?: boolean,
    getOnePartner?: any,
    moveStepByRequestID?: boolean,
    isUserAccounts?: boolean,
    getUserAccounts(value: []): void,
    viewAccountTable(value: boolean): void,
    viewAccounts: boolean,
    isApplyingPhoneAndID?: boolean,
}
class GetInfo extends Component<Props> {
    formRef = React.createRef<FormInstance>();
    inputsKey = "info"
    region = getRegion();       
    state = {
        load: false,
        errorMessage: '',
        companies: [],
        loadCompanies: false,
        errorMode: false,
        selectedPartnerId: "",
        isUserID: false
    }
    componentDidMount() {
        // this.props.stepperMoving(this.props.stepNumber + 1);
        // this.props.isAllCompanies && this.getCompanies(undefined);
        this.props.isNonDeployedCompanies && this.getCompanies(false);
        this.props.isDeployedCompanies && this.getCompanies(true);
        this.props.isAllCompanies && this.getCompanies();
        this.props.isPartner && this.getPartners();
        this.props.isHoldingComp && this.getHoldingCompanies()

        this.checkIfDeepLink()
    }

    checkIfDeepLink = () => {
        if (this.props.userStatus) {
            return
        }
        if (this.props.match.params.id) {
            if (this.props.match.params.id[0] === "0" && this.region === Region.SE) {
                this.props.match.params.id = this.props.match.params.id.slice(1)
            }
            this.setState({ isUserID: true }, () => {
                this.formRef.current?.setFieldsValue({
                    [this.inputsKey]: this.props.match.params.id
                })
                this.formRef.current?.submit()
            })
        }
    }
    getCompanies = async (deployed?: boolean) => {

        this.setState({ loadCompanies: true })

        const companies = await this.props.getApi(deployed ? deployedCompanies : this.props.isAllCompanies ? companiesApi : unDeployedCompanies);
        try {
            const res = await companies.payload;
            if (res.status === 200) {
                this.setState({ loadCompanies: false, companies: res.data });
                this.props.addCompanies(res.data)
            } else {
                this.setState({ errorMessage: res.message, loadCompanies: false, errorMode: true })
            }
        } catch (error) {
            this.setState({ errorMessage: errorMessage, loadCompanies: false, errorMode: true })
        }
    }


    getPartners = async () => {
        this.setState({ loadCompanies: true })
        try {
            const Partners = await this.props.getApi(getPartners);
            const res = Partners.payload
            if (res.status === 200) {
                this.setState({ loadCompanies: false, companies: res.partners })
            } else {
                this.setState({ errorMessage: res.message, loadCompanies: false, errorMode: true })
            }
        } catch (error) {
            this.setState({ errorMessage: errorMessage, loadCompanies: false, errorMode: true })
        }
    }

    savePartnerInfo = () => {
        if (this.props.isHoldingComp) {
            this.props.stepperMoving(this.props.stepNumber + 1);
            return
        }
        this.props.savePartnerID(this.state.selectedPartnerId);
        this.props.stepperMoving(this.props.stepNumber + 1);
    }

    getHoldingCompanies = async () => {

        this.setState({ loadCompanies: true })

        const holdingCompanies = await this.props.getApi(getCompaniesGroups);
        try {
            const res = await holdingCompanies.payload;
            if (res.status === 200) {
                this.setState({ loadCompanies: false, companies: res.data })
            } else {
                this.setState({ errorMessage: res.message, loadCompanies: false, errorMode: true })
            }
        } catch (error) {
            this.setState({ errorMessage: errorMessage, loadCompanies: false, errorMode: true })
        }
    }


    getDataInfo = async (value: any) => {
        if (this.props.moveStepByRequestID) {
            this.props.getRequestID(value.info);
            this.props.stepperMoving(this.props.stepNumber + 1);
            return

        }
        console.log("🚀 ~ file: getInfo.tsx ~ line 124 ~ GetInfo ~ getDataInfo= ~ value", value)
        let data;
        if (this.props.param) {
            data = `/${value[this.inputsKey]}`
        }
        else if (this.props.request) {
            data = `?issueID=1&advanceID=${value.requestID}`
        }
        else if (this.props.isAdjustment) {
            data = `?advanceID=${value.info}`
        }
        else if (this.state.isUserID) {
            data = `&userID=${value.info}`
        }
        else {
            data = value[this.inputsKey]
            console.log("🚀 ~ file: getInfo.tsx:168 ~ GetInfo ~ getDataInfo= ~ data:", data)
        }
        this.setState({ load: true })
        const getUserData = await this.props.getApi(`${this.props.onePartner ? getOnePartnerApi :
            `${this.props.apiLink}`}${data}${this.props.isApplyingPhoneAndID && !this.state.isUserID ? '&userID=' : ''}`);
        console.log(data);
        console.log("🚀 ~ file: getInfo.tsx:163 ~ GetInfo ~ getDataInfo= ~ this.props.apiLink:", this.props.apiLink)

        try {
            const res = await getUserData.payload;
            console.log("🚀 ~ file: getInfo.tsx:177 ~ GetInfo ~ getDataInfo= ~ res:", res)

            this.props.getOnePartner(res.partnerDetails)
            // if (res?.statusCode === 200) {
            //     this.props.stepperMoving(this.props.stepNumber + 1);
            //     this.props.getDataInfo(res.data);
            //     this.setState({ load: false })
            //     return
            // }
            if (res.status === 200) {
                if (this.props.isApprovedUser && res.userInfo.userStatusType === 'Approved') {
                    message.error(`The user is approved you don't have permission`)
                }
                else if (this.props.unSuspendUser && (res.userInfo.isSuspended === 'No')) {
                    message.error(`This user has not suspended`)
                }
                else if (this.props.suspendUser && (res.userInfo.isSuspended === 'Yes')) {
                    message.error(`This user has already been suspended`)
                }
                else {
                    if (this.props.userStatus) {
                        if (res.userInfo.companyID !== value.company) {
                            message.error("User's company is not matching the company you specified")
                            this.setState({ load: false })
                            return
                        }
                        res.userInfo && this.props.getDataInfo({ ...res.userInfo, selectedCompany: value.company })
                    }
                    else if (this.props.isAdjustment) {
                        delete res.status
                        this.props.getDataInfo({ ...res })
                    }
                    else {
                        if (res?.users) {
                            console.log('res.userInfo = ', res.users);
                            this.props.getUserAccounts(res?.users);
                            this.props.viewAccountTable(true);
                            this.setState({ load: false })
                            this.props.stepperMoving(this.props.stepNumber);
                            return

                        } else {
                            this.props.getDataInfo(res.userInfo ? res.userInfo : res.requestDetails ? res.requestDetails : res.userDocs ? res.userDocs : res.data);
                            this.props.viewAccountTable(false);
                        }
                    }
                    this.props.stepperMoving(this.props.stepNumber + 1);
                }
            } else if (this.props.isAdjustment && res.status === 400) {
                this.setState({ errorMessage: res.reason })
            } else {
                this.setState({ errorMessage: res.message })
            }
            this.setState({ load: false })
        } catch (error) {
            this.setState({ errorMessage: errorMessage, load: false })
        }
    }
    dropDownSearch = (input: string, option: { children: string; }) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    refreshPage = () => {
        window.location.reload();
    }
    changeCompanies = (value: any, data: any) => {
        if (this.props.isAllCompanies) {
            this.props.getDataInfo(value);
            return;
        }


        this.setState({ selectedPartnerId: value })
    }
    onIdentityMode = (isUserID: boolean) => {
        this.setState({ errorMessage: '', isUserID })
    }
    lookupCopy = () => {
        const {
            request, isAdjustment, isPartner, isHoldingComp, userStatus,
            isDeployedCompanies, isNonDeployedCompanies, isAllCompanies,
            isMultipleSelect, placeHolder,
        } = this.props;

        if (request) {
            return {
                title: 'Find a request',
                hint: 'Enter the request ID to continue.',
                companyLabel: 'Company',
                primaryLabel: 'Request ID',
            };
        }
        if (isAdjustment) {
            const primaryLabel = (placeHolder || 'Adjustment ID').replace(/^Enter\s+/i, '');
            return {
                title: 'Find a record',
                hint: `Enter the ${primaryLabel.toLowerCase()} to continue.`,
                companyLabel: 'Company',
                primaryLabel,
            };
        }
        if (userStatus) {
            return {
                title: 'Find a user',
                hint: 'Select the company, then search by phone number or user ID.',
                companyLabel: 'Company',
                primaryLabel: 'Phone number',
            };
        }
        if (isPartner) {
            return {
                title: 'Select a partner',
                hint: 'Choose the partner you want to open.',
                companyLabel: 'Partner',
                primaryLabel: 'Phone number',
            };
        }
        if (isHoldingComp) {
            return {
                title: 'Select a group',
                hint: 'Choose a company group to continue.',
                companyLabel: 'Company group',
                primaryLabel: 'Phone number',
            };
        }
        if (isDeployedCompanies || isNonDeployedCompanies || isAllCompanies) {
            return {
                title: 'Select a company',
                hint: isMultipleSelect ? 'Choose one or more companies to continue.' : 'Choose a company to continue.',
                companyLabel: 'Company',
                primaryLabel: 'Phone number',
            };
        }
        return {
            title: 'Find a user',
            hint: 'Search by phone number or user ID.',
            companyLabel: 'Company',
            primaryLabel: 'Phone number',
        };
    }
    render() {
        const { load, errorMessage, companies, loadCompanies, errorMode, isUserID } = this.state;
        const { isNonDeployedCompanies, isDeployedCompanies, isPartner, moveStepByRequestID, request, isHoldingComp, placeHolder, isAllCompanies, isMultipleSelect, userStatus, isAdjustment, viewAccounts } = this.props;
        const showCompany = Boolean(isDeployedCompanies || isNonDeployedCompanies || isAllCompanies || isPartner || isHoldingComp || userStatus);
        const showIdentity = !(isDeployedCompanies || isNonDeployedCompanies || isAllCompanies || isPartner || isHoldingComp) || Boolean(userStatus);
        const copy = this.lookupCopy();
        const primaryPlaceholder = (placeHolder && !userStatus) ? placeHolder : request ? 'Enter The Request ID' : 'Enter User’s Phone number';
        return (
            <>{!viewAccounts ?
                <div className="lookup">
                    {loadCompanies ? <div className="lookup__status"><Spinner size="large" /></div> : errorMode ? <div className="lookup__status"><OutPutResult status={'500'} title={'Oops!'} subTitle={'Something went wrong, please refresh and try againg'}
                        btnTitle={'Refresh the page'} btnClick={this.refreshPage} /></div> :
                        <Form
                            className="lookup__form"
                            layout="vertical"
                            requiredMark={false}
                            colon={false}
                            name="nest-messages"
                            onFinish={this.props.apiLink || moveStepByRequestID ? this.getDataInfo : this.savePartnerInfo}
                            ref={this.formRef}
                        >
                            <div className="lookup__card">
                                <img className="lookup__art" src={GetInfoPic} alt="" />
                                <h2 className="lookup__title">{copy.title}</h2>
                                <p className="lookup__hint">{copy.hint}</p>

                                {showCompany && (
                                    <Form.Item
                                        label={copy.companyLabel}
                                        name={this.props.userStatus ? "company" : this.inputsKey}
                                        rules={[{ required: true, message: 'Required' }]}
                                    >
                                        <Select
                                            className="lookup__select"
                                            placeholder={placeHolder ? placeHolder : 'Please select the company'}
                                            showSearch
                                            allowClear
                                            suffixIcon={<ChevronIcon />}
                                            mode={isMultipleSelect ? "multiple" : undefined}
                                            filterOption={((input, option: any) => this.dropDownSearch(input, option))}
                                            onChange={this.changeCompanies}
                                        >
                                            {companies.map((company: any, key: number) => {
                                                return <Option value={company.id} data={company} key={key}>{company.name}</Option>
                                            })}
                                        </Select>
                                    </Form.Item>
                                )}

                                {showIdentity && (
                                    <Form.Item name={this.inputsKey} rules={request ? [
                                        { required: true, message: 'Request ID is mandatory' }]
                                        : isAdjustment ? [
                                            { required: true, message: "Adjustment ID is Required" }]
                                            : [
                                                { required: true, message: 'Phone Or User ID is mandatory' },
                                            ]}>
                                        <IdentityFields
                                            primaryLabel={copy.primaryLabel}
                                            primaryPlaceholder={primaryPlaceholder}
                                            showAlternate={!request}
                                            alternateIsId={isUserID}
                                            onMode={this.onIdentityMode}
                                        />
                                    </Form.Item>
                                )}

                                {errorMessage ? <p className="lookup__error" role="alert">{errorMessage}</p> : null}

                                <Form.Item className="lookup__actions">
                                    <Button className="lookup__btn" shape="round" type="primary" loading={load} block htmlType="submit">
                                        Submit
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>}
                </div> : <UserAccounts />}
            </>

        )
    }
}
const mapStateToProps = (state: any) => ({
    info: state.actionsReducer.info,
    stepNumber: state.actionsReducer.stepNumber,
    viewAccounts: state.actionsReducer.viewAccounts,
})
export default withRouter(connect(mapStateToProps, {
    stepperMoving, getDataInfo, getUserAccounts, viewAccountTable,
    getApi, savePartnerID, addCompanies, getOnePartner, getRequestID
})(GetInfo))